function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "email");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-20px-/-Email-/-enabled",
  transform: "translate(-2.000000, -4.000000)",
  stroke: "#00AEFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "email",
  transform: "translate(2.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5,12.5 L1.5,12.5 C0.948,12.5 0.5,12.052 0.5,11.5 L0.5,1.5 C0.5,0.948 0.948,0.5 1.5,0.5 L14.5,0.5 C15.052,0.5 15.5,0.948 15.5,1.5 L15.5,11.5 C15.5,12.052 15.052,12.5 14.5,12.5 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "2.5 3.5 8 8 13.5 3.5"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.5,
  y1: 9.5,
  x2: 4,
  y2: 8,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 13.5,
  y1: 9.5,
  x2: 12,
  y2: 8,
  id: "Path"
}))));

var SvgEmaiIcon = function SvgEmaiIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmaiIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emaiIcon.2df30942.svg";
export { ForwardRef as ReactComponent };